/**
 * @file MessageOptOut.js
 * @description Displays an overview of message opt-outs based on user preferences.
 */

import React, { useState, useEffect } from 'react';
import LoadingWrapper from '../../ui/loaders/LoadingWrapper';
import style from './../IndividualPage.module.scss';
import Toast from '../../ui/toasts/Toast';
import { getNotificationCategories } from '../../../services/messageService';
import { getText } from '../../../i18n';

const MessageOptOut = ({ preferences, isLoading: parentIsLoading }) => {
    const [categories, setCategories] = useState([]);
    const [isLoadingCategories, setIsLoadingCategories] = useState(true);
    const optOutIds = preferences?.notificationCategoryOptOuts || [];

    useEffect(() => {
        loadNotificationCategories();
    }, []);

    const loadNotificationCategories = async () => {
        try {
            setIsLoadingCategories(true);
            const data = await getNotificationCategories();
            setCategories(data);
        } catch (error) {
            console.error('Could not fetch notification categories:', error);
            Toast.error(getText('msg_15e2cab7d987'));
        } finally {
            setIsLoadingCategories(false);
        }
    };

    const getOptOutsWithNames = () => {
        return optOutIds
            .map(id => {
                const category = categories.find(cat => cat.id === id);
                return category
                    ? {
                          id: category.id,
                          name: category.name,
                      }
                    : null;
            })
            .filter(Boolean); // Remove any null values
    };

    const isLoading = parentIsLoading || isLoadingCategories;
    const optOutsWithNames = getOptOutsWithNames();

    return (
        <LoadingWrapper isLoading={isLoading}>
            <div className={`form-control ${style.messageOptOut} ps-0 mb-3`}>
                {isLoading && <div>{getText('msg_b04ba49f8486')}</div>}

                {!isLoading && optOutsWithNames.length === 0 && (
                    <span className="text-muted m-0 p-0">
                        {getText('msg_3e09e5123bd6')}
                    </span>
                )}

                {!isLoading &&
                    optOutsWithNames.map(optOut => (
                        <span
                            key={optOut.id}
                            className={`badge-base badge-population-group mt-2 m-1`}
                        >
                            {optOut.name}
                        </span>
                    ))}
            </div>
        </LoadingWrapper>
    );
};

export default MessageOptOut;
